import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { MdDashboard, MdSchedule, MdChat, MdPerson, MdAssignment, MdEventAvailable, MdOutlineQuiz, MdEventNote } from 'react-icons/md';
import AuthService from '../services/authService';

const Aside = styled.aside`
  position: fixed;
  inset: 0 auto 0 0;
  z-index: 50;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e5e7eb;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04);
  transition: width 0.3s ease;
  width: ${(p) => (p.$open ? '256px' : '64px')};
`;

const TopBar = styled.div`
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #e5e7eb;
  padding: 0 16px;
`;

const BrandBadge = styled.div`
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #3b82f6; /* blue-500 */
  color: #fff;
  font-weight: 700;
  font-size: 12px;
`;

const Nav = styled.nav`
  flex: 1;
  padding: 16px 12px;
  overflow-y: auto;
`;

const NavLink = styled.a`
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 8px;
  padding: 10px 12px;
  color: ${(p) => (p.$active ? '#fff' : '#374151')};
  background: ${(p) => (p.$active ? '#3b82f6' : 'transparent')};
  text-decoration: none;
  font-size: 14px;
`;

const Footer = styled.div`
  border-top: 1px solid #e5e7eb;
  padding: 16px;
  color: #6b7280;
  font-size: 12px;
`;

export default function StudentSidebar({ isOpen }) {
  const currentPath = typeof window !== 'undefined' ? window.location.pathname : '/';
  const userInfo = AuthService.getUserInfo();
  const isParent = userInfo?.type === 'parent';

  const navigation = useMemo(() => ([
    { name: 'Dashboard', href: '/app/dashboard', icon: <MdDashboard /> },
    { name: 'Submissions', href: '/app/submissions', icon: <MdAssignment /> },
    { name: 'Attendance', href: '/app/attendance', icon: <MdEventAvailable /> },
    { name: 'Event Attendance', href: '/app/event-attendance', icon: <MdEventNote /> },
    { name: 'Timetable', href: '/app/timetable', icon: <MdSchedule /> },
    { name: 'My Exam', href: '/app/my-exam', icon: <MdOutlineQuiz /> },
    { name: 'Ticket', href: '/app/chat', icon: <MdChat /> },
    { name: 'Profile', href: '/app/profile', icon: <MdPerson /> },
  ]), []);

  const isActive = (href) => {
    if (href === '/app/dashboard') return currentPath === href;
    return currentPath.startsWith(href) && href !== '#';
  };

  return (
    <Aside $open={isOpen}>
      <TopBar>
        {isOpen ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <BrandBadge>MYC</BrandBadge>
            <span style={{ fontWeight: 700, fontSize: 16, color: '#111827' }}>{isParent ? 'Parent' : 'Student'}</span>
          </div>
        ) : (
          <BrandBadge>MYC</BrandBadge>
        )}
      </TopBar>
      <Nav>
        {navigation.map((item) => {
          const itemActive = isActive(item.href);
          return (
            <div key={item.name} style={{ marginBottom: 6 }}>
              <NavLink href={item.href} $active={itemActive}>
                <span>{item.icon}</span>
                {isOpen && <span>{item.name}</span>}
              </NavLink>
            </div>
          );
        })}
      </Nav>
      {isOpen && (
        <Footer>
          <div>
            <div style={{ fontWeight: 600 }}>{isParent ? 'Parent Panel' : 'Student Panel'}</div>
            {isParent && (
              <div
                style={{
                  marginTop: 6,
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 6,
                  padding: '4px 10px',
                  borderRadius: 999,
                  background: '#fef3c7',
                  border: '1px solid #facc15',
                  color: '#92400e',
                  fontSize: 11,
                  fontWeight: 600,
                }}
              >
                <span style={{ width: 6, height: 6, borderRadius: 999, background: '#f59e0b' }} />
                <span>Parent view</span>
              </div>
            )}
            <div style={{ marginTop: 8 }}>Version 1.0.0</div>
          </div>
        </Footer>
      )}
    </Aside>
  );
}
